<template>
  <div class="about">
    <div class="container">
      <!-- 跳转到about界面的按钮 -->
      <button class="gotoBtn" @click="gotoHome">跳转</button>
      <City></City>
    </div>
  </div>
</template>

<script>
// import City from '../components/City.vue'
export default{
  name:'AboutCity',
  // components:{City},
  methods: {
    gotoHome(){
      // 跳转到home界面
      // window.location.replace('/');
    }
  },
}
</script>

<style scoped>
.about{
  /* position: absolute; */
  width: 100%;
  height: 100vh;
  margin: 0;
  border:1px solid red;
  /* background-color: blueviolet; */

}
.container{
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: aqua;
}
.gotoBtn{
  position: absolute;
  top: 2%;
  left: 2%;
}
</style> 
